import { skipToken } from '@reduxjs/toolkit/query';
import { useOnMissionV3SubscriptionQuery } from 'services/missionV3';

interface Props {
    vin?: string;
}

const useGetMissionData = ({ vin }: Props) => {
    const { data, isFetching, isError } = useOnMissionV3SubscriptionQuery(vin ?? skipToken);

    return {
        data,
        isFetching,
        isError,
    };
};

export default useGetMissionData;
